import { SERVICES } from "./services";
import { LEGAL_TEXT } from "./legal";

export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Strong Roots. Strategic Growth.",
    line1: "Building Strong",
    line2: "Foundations for",
    line3: "Confident Growth.",
    tagline:
      "Bookkeeping and financial guidance for small businesses throughout Greater Cincinnati and Southeast Indiana.",
    subtext:
      "Expert bookkeeping, reporting, payroll and advisory services to help your business grow with clarity, confidence and a strong financial foundation.",
  },
  aboutTeaser: {
    heading1: "More Than Numbers.",
    heading2: "We're Your Partner.",
    copy: "We partner with businesses to deliver financial clarity and strategic insights — so you can make confident decisions and build a stronger future.",
  },
  values: [
    { title: "Rooted in Integrity", copy: "We lead with honesty, transparency, and trust in everything we do." },
    { title: "Trusted Expertise", copy: "Reliable guidance backed by experience and a commitment to excellence." },
    { title: "Strategic Insights", copy: "Actionable insights that help you grow and strengthen your business." },
    { title: "Committed to Your Growth", copy: "Your success is our priority, every step of the way." },
  ],
  experience: {
    heading: "Experience Behind Rooted",
    intro:
      "Rooted is backed by nearly two decades of experience identifying financial issues, strengthening controls, improving processes, and helping organizations make better-informed decisions.",
    items: [
      {
        stat: "$195K",
        label: "Tax Overpayments Recovered",
        details:
          "Identified $195,000 in payroll-related state tax overpayments and led the work necessary to ensure the funds were recouped.",
      },
      {
        stat: "$2M",
        label: "Posting Omission Corrected",
        details:
          "Redesigned payroll reconciliation processes and identified a $2 million posting omission, ensuring payroll liabilities were accurately recorded and supported.",
      },
      {
        stat: "$121K",
        label: "Overpayment Prevented",
        details:
          "Prevented a $121,000 incentive compensation overpayment through a detailed review of plan administration and payout calculations.",
      },
      {
        stat: "Approved",
        label: "Incentive Plan Successfully Redesigned",
        details:
          "Identified a sales incentive plan that was no longer producing the intended results and developed a cost-neutral redesign that was approved by the Compensation Committee.",
      },
    ],
  },
  cta: {
    eyebrow: "Ready to Grow with Confidence?",
    heading: "Let's Build a Stronger Financial Future Together.",
    copy: "Request a consultation today and take the first step toward financial clarity and business growth.",
  },
  about: {
    line1: "Growth Starts",
    line2: "Below the Surface.",
    intro:
      "Strong businesses, like strong trees, are built on what you can't always see — healthy roots. Ours is the quiet, careful work that makes confident growth possible.",
    jenniferHeading1: "The Advisor Behind",
    jenniferHeading2: "the Numbers.",
    bio1:
      "Jennifer, a Certified Payroll Professional, founded Rooted Business Advisors to give small business owners something every business deserves: an approachable financial partner who understands their numbers and genuinely cares about their success. With nearly two decades of experience spanning banking, accounting, payroll, and incentive compensation—including leadership roles managing teams and partnering across finance, HR, legal, risk, and operations—Jennifer understands how accurate financial information creates clarity and supports better decisions.",
    bio2:
      "She brings both precision and perspective to every engagement, helping business owners strengthen their financial foundations, relieve the burden of managing the books, and build more sustainable businesses. Rooted also reflects what Jennifer values personally: meaningful work, financial security, and the freedom to be present for her family. Her philosophy is simple: when your financial foundation is strong, every decision becomes easier.",
    chapters: [
      {
        title: "Our Roots",
        copy: "Rooted Business Advisors was founded on a simple belief: small businesses deserve the same caliber of financial guidance as the big ones. We started with bookkeeping done right — and grew into a full advisory partner.",
      },
      {
        title: "Our Approach",
        copy: "No jargon, no black boxes. We keep your books clean, your reports clear, and your questions answered in plain English — so every decision you make rests on solid ground.",
      },
      {
        title: "Our Promise",
        copy: "Honesty in every number, transparency in every report, and a genuine stake in your growth. When your business thrives, we've done our job.",
      },
    ],
  },
  coreValues: [
    {
      title: "Integrity",
      copy: "We always do the right thing, even when no one is watching. We tell the truth, protect confidential information, and act in our clients' best interests.",
    },
    {
      title: "Transparency",
      copy: "Honest conversations build strong businesses. We communicate openly, price fairly, and explain financial information in plain language so clients always know where they stand.",
    },
    {
      title: "Partnership",
      copy: "Every business has a story worth understanding. Before offering advice, we listen. We take time to understand our clients' goals, challenges, and the people behind the business.",
    },
    {
      title: "Excellence",
      copy: "Accuracy earns trust. Our work is thorough, dependable, and completed with the care we'd expect for our own business.",
    },
    {
      title: "Stewardship",
      copy: "We help build businesses that support meaningful lives. Financial success isn't just about profit—it's about creating stability, opportunity, and the freedom to focus on what matters most.",
    },
  ],
  whoWeServe: {
    heading: "Who We Work Best With",
    intro:
      "Rooted partners with established small businesses whose financial needs have grown beyond what the owner can—or should—manage alone. You may be ready for Rooted if:",
    bullets: [
      "Your business is growing, but bookkeeping is taking too much of your time.",
      "You have multiple accounts, employees or contractors, payroll, and increasingly complex financial activity.",
      "You receive financial reports but aren't confident you understand what they're telling you.",
      "You need more than accurate books—you want insight that helps you plan and make better decisions.",
      "Your tax professional handles the annual return, but you need reliable financial support throughout the year.",
      "You value clear communication, consistent processes, and an ongoing relationship with someone who understands your business.",
    ],
    outro:
      "You don't need to have perfectly organized books before reaching out. Rooted can help you move from managing the numbers on your own to having a trusted accounting partner who brings clarity, structure, and confidence to your business.",
  },
  contact: {
    phoneDisplay: "(513) 288-8842",
    email: "Jennifer@RootedBusinessAdvisors.com",
    line1: "Let's Plant",
    line2: "Something Together.",
    intro:
      "Tell us a little about your business and where you'd like to grow. Jennifer will reach out personally to schedule your consultation.",
  },
  footer: {
    tagline: "Financial clarity. Confident decisions. Stronger businesses.",
  },
  legal: LEGAL_TEXT,
  services: SERVICES,
};
